import "../../stylesheets/PopupRegister.css";
import React from "react";

function PopupError(props) {
  const close = () => props.setOpenErrorPopup(false);

  return (
    <>
      <div className="popup-register-container popup-deactivate-user popup-error-game">
        <div className="popup">
          <div className="lightgreen">
            <button className="btn-close-popup" onClick={close}>
              X
            </button>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/stage_characters/Popup_Imagen.png"
              }
              alt=""
            />
          </div>
          <h1>ERROR</h1>
          <h2>{props.description}</h2>
          <button
            className="btn lightgreen-btn"
            onClick={() => {
              close();
              props.setRefresh(true);
            }}
          >
            Aceptar
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupError;
